import React, { useEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import "simplebar-react/dist/simplebar.min.css";

import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";

import Link from "@atoms/Link";
import Select from "@atoms/Select";

import { URLS } from "@const/urls";

import useHeaderScroll from "@hooks/useHeaderScroll";
import useLanguage from "@hooks/useLanguage";

import { useLayoutStore } from "@store/layout";

const SUB_PAGES = [
  { label: "Contact", id: "contact", href: URLS.INFORMATION_CONTACT },
  { label: "Membership", id: "membership", href: URLS.INFORMATION_MEMBERSHIP },
];

const SUB_PAGES_INFO = [
  { label: "Shipping and Returns", id: "shipping-and-returns", href: URLS.SHIPPING_AND_RETURNS },
  { label: "Terms", id: "terms-and-conditions", href: URLS.TERMS_AND_CONDITIONS },
  { label: "Privacy Policy", id: "privacy-policy", href: URLS.PRIVACY_POLICY },
];

const JP_SUB_PAGES = [
  { label: "Contact", id: "contact", href: URLS.INFORMATION_CONTACT },
  { label: "FAQ", id: "faq", href: URLS.INFORMATION_FAQ },
];

const JP_SUB_PAGES_INFO = [
  { label: "Shipping and Returns", id: "shipping-and-returns", href: URLS.SHIPPING_AND_RETURNS },
  { label: "Terms", id: "terms-and-conditions", href: URLS.TERMS_AND_CONDITIONS },
  { label: "Privacy Policy", id: "privacy-policy", href: URLS.PRIVACY_POLICY },
];

export default function Information() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { showFooter } = useLayoutStore();
  const { isPC } = useCheckDevice();
  const { lang } = useLanguage();

  useEffect(() => {
    showFooter(true);
    window.scrollTo(0, 0);
  }, [pathname]);

  useHeaderScroll();

  return (
    <>
      <section className="pc:col-span-2 pc:top-30 sticky top-0 z-10 col-span-8 h-fit" id="filter">
        {isPC ? (
          <section className="flex flex-col gap-10">
            <div className="flex flex-col gap-1">
              {(lang === "jp" ? JP_SUB_PAGES : SUB_PAGES).map(({ href, label }) => (
                <Link as="text" className="flex" href={href} isActive={pathname === href} key={href}>
                  {label}
                </Link>
              ))}
            </div>
            <div className="flex flex-col gap-1">
              {(lang === "jp" ? JP_SUB_PAGES_INFO : SUB_PAGES_INFO).map(({ href, label }) => (
                <Link as="text" className="flex" href={href} isActive={pathname === href} key={href}>
                  {label}
                </Link>
              ))}
            </div>
          </section>
        ) : (
          <div className="flex items-center gap-2 bg-white py-2.5">
            <span className="text-base!">Viewing:</span>
            <Select
              as="square"
              onChange={(e) => {
                navigate(e.target.value);
              }}
              options={(lang === "jp" ? [...JP_SUB_PAGES, ...JP_SUB_PAGES_INFO] : [...SUB_PAGES, ...SUB_PAGES_INFO]).map(
                ({ href, label }) => ({ name: label, value: href }),
              )}
              value={pathname}
              variant="secondary"
            />
          </div>
        )}
      </section>
      <section className="pc:col-span-10 col-span-8 grid grid-cols-subgrid gap-y-5">
        <Outlet />
      </section>
    </>
  );
}
